import NextLink from '@/components/next-link';
import ArrowIcon from '@/components/ui/icons/arrow-icon';
import useCategoryStore from '@/store/category.store';
import { useTranslations } from 'next-intl';
import { useState } from 'react';

const ResponsiveCategories = ({ onClose }) => {
  const t = useTranslations('common');
  const [isOpen, setIsOpen] = useState(false);
  const menuTreeData = useCategoryStore((state) => state.menuTreeData);

  return (
    <>
      <div className='flex flex-col border-b border-neutral-200 p-3'>
        <button
          onClick={() => setIsOpen(!isOpen)}
          className='flex cursor-pointer items-center justify-between'
        >
          <h2 className='text-xs leading-6 font-bold text-black'>
            {t('Categories')}
          </h2>
          <ArrowIcon
            className={`size-2.5 transition-transform rtl:rotate-90 ${
              isOpen ? 'rotate-360' : 'rotate-270'
            }`}
            strokeWidth={2}
          />
        </button>

        {isOpen && menuTreeData?.length > 0 && (
          <ul className='space-y-3 py-2 ps-1.5'>
            {menuTreeData?.map((category, index) => (
              <li
                key={index}
                className='text-[10px] font-normal text-black uppercase'
              >
                <NextLink onClick={() => onClose()} href={category?.currentURL}>
                  {category?.name}
                </NextLink>
              </li>
            ))}
          </ul>
        )}
      </div>
    </>
  );
};

export default ResponsiveCategories;
